import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'transformDoc'
})
export class TransformDocPipe implements PipeTransform {

    transform(input: any): any {
        switch (input) {
            case 'INVOICE':
            case '01':
                input = 'Factura';
                break;
            case 'TICKET':
            case '03':
                input = 'Boleta';
                break;
            case 'DEBIT_NOTE':
            case '08':
                input = 'Nota de Débito';
                break;
            case 'CREDIT_NOTE':
            case '07':
                input = 'Nota de Crédito';
                break;
            case '40':
            case 'PERCEPTION':
                input = 'Percepción';
                break;
            case 'RETENTION':
            case '20':
                input = 'Retención';
                break;
            case 'SUMMARY_DOCUMENT':
                input = 'Resumen Diario';
                break;
            case 'DESPATCH_ADVICE':
            case '09':
                input = 'Guía de Remisión';
                break;
            case 'DESPATCH_TRANSPORT':
            case '31':
                input = 'Guía Transportista';
                break;
            case 'RA_VOIDED_DOCUMENT':
                input = 'Comunicación de Baja';
                break;
            case 'RR_VOIDED_DOCUMENT':
                input = 'Resumen de Reversiones';
                break;
            case 'CORRUPTED_DOCUMENT':
                input = 'Documento Corrupto';
                break;
            case 'INVALID_DOCUMENT':
                input = 'Documento Invalido';
                break;
            case '-1':
                input = 'Todos';
                break;
        }


        return input;
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/pipes/string/transformDoc.pipe.ts